'use strict'

export function getMenu() {
	return [
		{
			title: 'Maçonnerie et Dallage BA',
			directory: 'entreprise/',
			image: 'dallage.png',
			route: 'realisations?filter=1',
      contents: [
        'maçonnerie',
        'réseau et assainissement',
      ]
		},
		{
			title: 'Portail',
			directory: 'entreprise/',
			image: 'portail.png',
			route: 'realisations?filter=2',
      contents: [
        'portail coulissant',
        'portail autoporté',
        'cloture'
      ]
		},
		{
			title: 'Aménagement extérieur',
			directory: 'entreprise/',
			image: 'amenagement.jpg',
			route: 'realisations?filter=3',
      contents: [
        'terrasse pierre',
        'terrasse bois',
        'terrasse mixte pierre/bois'
      ]
		}
    ]
}

export function getDirectoryForDevice(size) {
	return size<=1170?'mobile/':'';
}




// WEBPACK FOOTER //
// ./src/actions/generalData.js